import Component from "./Component.jsx";

export default Component;
